import React, { useRef, useState } from 'react'

import { DDSTooltip } from 'den-design-system'
import { TooltipProps } from './Tooltip.types'
import pallete from '../../../global/newPallete'

const Tooltip: React.FC<TooltipProps> = ({
  id,
  label,
  additionalLabel,
  className = '',
  position = 'top',
  children,
  style
}) => {
  const [visible, setVisible] = useState(false)
  const delayRef = useRef<NodeJS.Timeout | null>(null)

  const handleMouseEnter = () => {
    delayRef.current = setTimeout(() => setVisible(true), 400)
  }

  const handleMouseLeave = () => {
    if (delayRef.current) clearTimeout(delayRef.current)
    setVisible(false)
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {visible && (
        <DDSTooltip
          id={id}
          label={label}
          additionalLabel={additionalLabel}
          theme='light'
          shape='roundedRectangle'
          className={`override-tooltip-arrow ${className}`}
          position={position}
          style={{
            zIndex: 999999,
            backgroundColor: pallete.colors.surface1,
            ...style
          }}
        >
          {children}
        </DDSTooltip>
      )}
      {!visible && children}
    </div>
  )
}

export default Tooltip
